import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Consumer } from '../context';
import './style.css';

const RadioButton = ({ label, option, className, ...rest }) => (
  <Consumer>
    {({ setValue, value }) => {
      const on = value === option;
      const customClassName = classNames('radio-button-input', className, {
        '-on': on,
        '-off': !on,
      });

      /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
      return (
        <label
          className={customClassName}
          htmlFor={option}
          onClick={() => {
            setValue(option);
          }}
          {...rest}
        >
          <span>{label}</span>
          <input type="radio" value={on} onChange={() => {}} />
        </label>
      );
    }}
  </Consumer>
);
/* eslint-enable jsx-a11y/no-noninteractive-element-interactions */

RadioButton.propTypes = {
  label: PropTypes.string.isRequired,
  option: PropTypes.string.isRequired,
  className: PropTypes.string,
};

RadioButton.defaultProps = {
  className: '',
};

export default RadioButton;
